import { nanoid } from 'nanoid'
import { toastStore } from 'shared/ui'
import { logger } from 'shared/lib'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { checkUsageAgent } from 'pages/chatbot/pages/calling/actions/checkUsageAgent/checkUsageAgent'

export const disableAgent = ({
  id,
  disableRequest,
}: {
  id: number
  disableRequest: () => Promise<unknown>
}) => {
  const disable = async () => {
    try {
      const isUsage = await checkUsageAgent(id, 'disable')
      if (isUsage) return
      const modalId = nanoid()
      modalStore.addModal({
        type: ModalTypeList.ALERT,
        id: modalId,
        title: 'Disable AI Agent?',
        desc: 'This will end all active conversations between the AI Agent and enrolled contacts',
        width: 280,
        primaryAction: {
          text: 'Disable',
          onAction: async () => {
            await disableRequest()
            modalStore.closeModal(modalId)
          },
        },
        secondaryAction: {
          text: 'Cancel',
          onAction: () => {
            modalStore.closeModal(modalId)
          },
        },
      })
    } catch (e) {
      logger.error(e)
      toastStore.add({
        type: 'error',
        title: 'Something went wrong, try again!',
      })
    }
  }
  return disable()
}
